import Afiche from "./Afiche"

const Today = (props: any) : JSX.Element => {
  return <Afiche />
} 

export default Today